const border = '1px solid #e5e7eb';

export const cellStyle = { textAlign: 'right', whiteSpace: 'nowrap', padding: '0.5rem 0.75rem', border: 0 };
export const textCellStyle = { textAlign: 'left', padding: '0.5rem 0.75rem', border: 0 };

export const negativeColor = '#cc4b37';
export const amountStyle = (value, base = cellStyle) => (value < 0 ? { ...base, color: negativeColor } : base);

const headTypography = {
    fontSize: '0.72rem',
    fontWeight: 600,
    color: '#555',
    textTransform: 'uppercase',
    letterSpacing: '0.03em',
    whiteSpace: 'nowrap',
};
export const headStyle = { ...cellStyle, ...headTypography };
export const headTextStyle = { ...textCellStyle, ...headTypography };
export const headCenterStyle = { ...headStyle, textAlign: 'center' };

export const rowHeadStyle = { ...textCellStyle, fontWeight: 600 };
export const groupStart = { borderLeft: border };
export const linkStyle = { color: '#1779ba', textDecoration: 'underline', cursor: 'pointer' };

export const cardStyle = {
    overflowX: 'auto',
    backgroundColor: '#fff',
    border,
    borderRadius: '0.5rem',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
};
export const tableStyle = { width: '100%', fontSize: '0.85rem', margin: 0, borderCollapse: 'collapse' };
export const headRowStyle = { backgroundColor: '#f6f7f9', borderBottom: border };
export const footRowStyle = { backgroundColor: '#f6f7f9', borderTop: '2px solid #d0d4da', fontWeight: 'bold' };

export const stripeStyle = (index) => ({
    backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
    borderBottom: '1px solid #f0f1f3',
});

export const pageHeaderStyle = { margin: '0 0 1rem' };
